/**
 * Add zeros (0) before string when length is less then 8
 */
const idWithZeros = (id) => {
  if (!id) return ''
  let idString = id.toString()
  while (idString.length < 8) {
    idString = '0' + idString
  }
  return idString
}

export default idWithZeros
